import { request } from '../request'

export class RegistrationService {

  registerCustomer(body: Object): Promise<any> {
    return request.post('/api/registration.json', body)
  }

}
